import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

export default function RowRadioButtonsGroup({ labels}) {
    const [value, setValue] = React.useState('');

    const handleChange = (event) => {
        console.log('before change: ', value)
        setValue(event.target.value);

        console.log('after change: ', value)

    };

    return (
        <FormControl component="fieldset" >
            <RadioGroup row aria-label="gender" name="row-radio-buttons-group"
                        value={value}
                        onChange={handleChange}  sx={{
                '& .MuiSvgIcon-root': {
                    fontSize: 28,
                    color: '#DE5103'
                },
                '& .MuiFormControlLabel-label': {
                    fontSize: 15
                }
            }}>
                {labels.map((label, index) => (
                    <FormControlLabel key={index} value={label} control={<Radio size='large'/>} label={label} />
                ))}
            </RadioGroup>
        </FormControl>
    );
}